import { render, staticRenderFns } from "./forwards.vue?vue&type=template&id=36de0153&"
import script from "./forwards.vue?vue&type=script&lang=js&"
export * from "./forwards.vue?vue&type=script&lang=js&"
import style0 from "./forwards.vue?vue&type=style&index=0&id=36de0153&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports